import { render } from "./SuccessModal.vue?vue&type=template&id=64f6b027"
import script from "./SuccessModal.vue?vue&type=script&lang=js"
export * from "./SuccessModal.vue?vue&type=script&lang=js"

import "./SuccessModal.vue?vue&type=style&index=0&id=64f6b027&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__